import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiEdit2, FiTrash2, FiPlus } from 'react-icons/fi';
import { getServices, deleteService } from '../../api';
import { useToast } from '../../components/Toast';
import Loader from '../../components/Loader';

export default function AdminServices() {
  const [services, setServices] = useState(null);
  const { toast, ToastHost } = useToast();

  const load = () => getServices().then(setServices).catch(() => setServices([]));
  useEffect(() => { load(); }, []);

  const handleDelete = async (s) => {
    if (!window.confirm(`Delete "${s.title}"?`)) return;
    try { await deleteService(s._id); toast('Service deleted'); load(); }
    catch (e) { toast('Delete failed', 'error'); }
  };

  if (!services) return <Loader />;

  return (
    <div>
      <div className="acontent__head">
        <h1>Services <span className="muted" style={{ fontSize: 16 }}>({services.length})</span></h1>
        <Link to="/admin/services/new" className="btn btn-primary btn-sm"><FiPlus /> Add Service</Link>
      </div>

      {services.length === 0 ? (
        <div className="empty"><div className="empty__icon">🧩</div><h3>No services yet</h3><Link to="/admin/services/new" className="btn btn-primary mt-2">Add a service</Link></div>
      ) : (
        <div className="table-wrap">
          <table className="atable">
            <thead><tr><th>Icon</th><th>Title</th><th>Tags</th><th>Featured</th><th></th></tr></thead>
            <tbody>
              {services.map((s) => (
                <tr key={s._id}>
                  <td style={{ fontSize: 24 }}>{s.icon}</td>
                  <td>{s.title}</td>
                  <td>
                    <div className="flex gap wrap">
                      {(s.tags || []).slice(0, 3).map((t) => <span key={t} className="tag-chip">#{t}</span>)}
                    </div>
                  </td>
                  <td>{s.featured ? '⭐' : '—'}</td>
                  <td>
                    <div className="row-actions">
                      <Link to={`/admin/services/${s._id}`} className="icon-btn"><FiEdit2 /></Link>
                      <button className="icon-btn danger" onClick={() => handleDelete(s)}><FiTrash2 /></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <ToastHost />
    </div>
  );
}
